import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import LanguageLayout from './LanguageLayout';
import { userRoutes } from './routes/user.routes';
import { adminRoutes } from './routes/admin.routes';
import ProtectedRoute from './layouts/ProtectedRoute';
import LoginPage from './pages/admin/LoginPage';

import './i18n';
import './index.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const router = createBrowserRouter([
  {
    path: "/:lang",
    element: <LanguageLayout />,
    children: [
      userRoutes,
    ]
  },
  {
    element: <ProtectedRoute />,
    children: [
      adminRoutes,
    ]
  },
  {
    path: "/login",
    element: <LoginPage />
  },
  {
    path: "/",
    element: <Navigate to="/vi" replace />
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);